/**
 * 页面跳转路由配置
 */
export default class RouteConfig {
  /**
   * 根目录
   */
  static root: string | undefined = process.env.REACT_APP_PUBLISH_PATH;

  static host: string | undefined = process.env.REACT_API_ADDRESS;

  /**
   * 后台管理根目录
   */
  static manageRoot: string | undefined = process.env.REACT_APP_MANAGE_PATH + '/';

  /**
   * 宣传页
   */
  static introduction: string = RouteConfig.root + 'index.html?page=introduction#/home';

  /**
   * 首页
   */
  static home: string = (RouteConfig.host || '') + (RouteConfig.root || '/') + 'index.html?page=home#/home';

  /**
   * 关注产品
   */
  static followDeal: string = RouteConfig.root + 'account.html#/user/follow?type=product';
  
  /**
   * 我关注的专家
   */
  static followerExpert: string = RouteConfig.root + 'account.html#/user/follow?type=expert-follower';
  
  /**
   * 关注我的专家
   */
  static followingExpert: string = RouteConfig.root + 'account.html#/user/follow?type=expert-following';

  /**
   * 帮助文档
   */
  static usehelp: string = RouteConfig.root + 'account.html#/common/help-document';

  /**
   * 意见反馈
   */
  static feedback: string = RouteConfig.root + 'account.html#/common/feedback';

  /**
   * 市场总览
   */
  static marketSummary: string = RouteConfig.root + 'market.html#/analysis/market-summary';

  /**
   * 意见反馈提交成功
   */
  static userHelpSuccess: string = RouteConfig.root + 'account.html#/common/success/feedback';

  /**
   * 搜索结果
   */
  static search: string = RouteConfig.root + 'index.html#/main/search';

  /**
   * 登录
   */
  static login: string = RouteConfig.root + 'sign.html#/login';

  /**
   * 宣传页注册
   */
  static registerOfIntroduction: string = RouteConfig.root + 'account.html?page=register&source=introduction#/main/register';

  /**
   * 头部注册
   */
  static registerOfHeader: string = RouteConfig.root + 'account.html?page=register&source=header#/main/register';

  /**
   * 登录页注册
   */
  static registerOfLogin: string = RouteConfig.root + 'account.html?page=register&source=login#/main/register';

  /**
   * 注册成功
   */
  static registerSuccess: string = RouteConfig.root + 'account.html#/success/register';

  /**
   * 忘记密码
   */
  static resetPwd: string = RouteConfig.root + 'account.html#/main/resetpwd';
  /** 
   * 预览专家
   */
  static expertPreview: string = RouteConfig.root + 'expert.html#/resume';

  /** 
   * 产品基本分析
   */
  static dealStaticAnalysis: string = RouteConfig.root + 'product.html#/detail/basic-analysis';

  /**
   * 证券信息
   */
  static investmentSecurityInfo: string = RouteConfig.root + 'investment.html#/security/info?security_id=';

  /** 
   * 产品要素
   */
  static productDealInfo: string = RouteConfig.root + 'product.html#/detail/basic-info?deal_id=';

  /** 
   * 产品文档
   */
  static dealDocument: string = RouteConfig.root + 'product.html#/detail/document?deal_id=';

  /** 
   * 产品主体
   */
  static productOriginator: string = RouteConfig.root + 'product.html#/detail/originator';

  /** 
   * 证券定价-定价
   */
  static investmentSecurityPricing: string = RouteConfig.root + 'investment.html#/security/pricing';

  /** 
   * 证券定价-现金流
   */
  static investmentSecurityCashflow: string = RouteConfig.root + 'investment.html#/security/cashflow';

  /** 
   * 机构详情
   */
  static organizationDetail: string = RouteConfig.root + 'organization.html#/detail/info?organization_id=';

  /** 
   * 机构-参与项目
   */
  static historicalIssue: string = RouteConfig.root + 'organization.html#/detail/historical-issue';
  /** 
   * 产品列表
   */
  static productList: string = RouteConfig.root + 'product.html#/list/product';

  /** 
   * 过会产品列表
   */
  static dealIssuingList: string = RouteConfig.root + 'product.html#/list/deal-issuing';

  /**
   * 新闻详情
   */
  static newsDetail: string = RouteConfig.root + 'market.html#/daily/news-info';

  /**
   * 政策法规详情
   */
  static lawPolicyDetail: string = RouteConfig.root + 'market.html#/daily/law-policy-info?id=';

  /**
   * 首单风云榜
   */
  static firstDealRank: string = RouteConfig.root + 'market.html#/detail/first-deal-rank';

  /**
   * 个人履历
   */
  static userProfile: string = RouteConfig.root + 'account.html#/user/profile';

  /**
   * 平台首页-云平台
   */
  static indexWeb: string = RouteConfig.root + 'index.html#/web';

  /**
   * 平台首页-移动端
   */
  static indexApp: string = RouteConfig.root + 'index.html#/app';

  /**
   * 平台首页-桌面端
   */
  static indexDesktop: string = RouteConfig.root + 'index.html#/desktop';

  static chartCnabsLink: string = 'http://cn-abs.com';

  /**
   * 组合证券
   */
  static portfolioSecurityInfo: string = RouteConfig.root + 'investment.html#/portfolio/monitor/security?id=';

  /**
   * 现金流预测
   */
  static portfolioCashFlowForecast: string = RouteConfig.root + 'investment.html#/portfolio/monitor/cashflow';

  /**
   * 现金流预测详细
   */
  static portfolioCashFlowDetail: string = RouteConfig.root + 'investment.html#/portfolio/monitor/cashflowdetail';

  /**
   * 组合新闻
   */
  static portfolioNewsInfo: string = RouteConfig.root + 'investment.html#/portfolio/monitor/news?id=';

  static expertSquare: string = RouteConfig.root + 'expert.html#/square';

  /**
   * 会议详情
   */
  static conferenceInfo: string = RouteConfig.root + 'education.html#/conference/info';

  /**
   * 细分市场
   */
  static productCategory: string = RouteConfig.root + 'market.html#/analysis/product-category';

  /**
   * 发行统计
   */
  static distributionStatistics: string = RouteConfig.root + 'market.html#/analysis/distribution-statistics';

  /**
   * 存量统计
   */
  static stockStatistics: string = RouteConfig.root + 'market.html#/analysis/stock-statistics';

  /**
   * 基础资产
   */
  static basicAssets: string = RouteConfig.root + 'market.html#/analysis/basic-assets';

  /**
   * 产品证券
   */
  static productSecurity: string = RouteConfig.root + 'market.html#/analysis/product-security';

  /**
   * 市场统计
   */
  static statistics: string = RouteConfig.root + 'market.html#/analysis/statistics';

  /**
   * 信贷ABS
   */
  static creditStatistics: string = RouteConfig.root + 'market.html#/analysis/primary/credit-statistics';

  /**
   * 企业ABS
   */
  static enterpriseStatistics: string = RouteConfig.root + 'market.html#/analysis/primary/enterprise-statistics';

  /**
   * ABN市场
   */
  static abnStatistics: string = RouteConfig.root + 'market.html#/analysis/primary/abn-statistics';

  /**
   * 我的参会
   */
  static userConference: string = RouteConfig.root + 'account.html#/user/conference';

  /**
   * 我的参会
   */
  static conferenceApplySuccess: string = RouteConfig.root + 'education.html#/conference/apply-success';

  /**
   * 站内信收件箱
   */
  static internalMessage: string = RouteConfig.root + 'account.html#/user/internal-message/receive';

  /**
   * 站内信已发送
   */
  static internalMessageHasSend: string = RouteConfig.root + 'account.html#/user/internal-message/send';
  /**
   * 版本介绍页
   */
  static versionLog: string = RouteConfig.root + 'account.html#/user/version-log';

  /**
   * 研究专区管理
   */
  static organizationZoneManage: string = RouteConfig.root + 'education.html#/organization-zone-manage?type=';

  /**
   * 二级市场
   */
  static secondaryMarket: string = RouteConfig.root + 'investment.html#/trade/secondary-market';
  
  /**
   * 公司简介
   */
  static company: string = RouteConfig.root + 'index.html#/about-us?type=company';
  /**
   * 团队介绍
   */
  static team: string = RouteConfig.root + 'index.html#/about-us?type=team';
  /**
   * 联系我们
   */
  static contactUs: string = RouteConfig.root + 'index.html#/about-us?type=contact-us';

  /**
   * 手机端的日报界面
   */
  static report: string = RouteConfig.root + 'absreport.html#/daily/report';

  /**
   * 市场交易管理
   */
  static market: string = RouteConfig.manageRoot + 'Admin/primary';

  /**
   * 研报管理
   */
  static factroy: string = RouteConfig.manageRoot + 'Admin/Analyst/UpdateDealDataExcel.aspx';

  /**
   * 用户管理
   */
  static userAccount: string = RouteConfig.manageRoot + 'Admin/Marketing/safs.aspx';

  /**
   * 机构账户管理
   */
  static organizationAccount: string = RouteConfig.manageRoot + 'Admin/Marketing/Enterprise.aspx';

  /**
   * 异常账户管理
   */
  static abnormalAccount: string = RouteConfig.manageRoot + 'Admin/Marketing/AbnormalAccount.aspx';

  /**
   * 专家资料编辑
   */
  static expertUserAccount: string = RouteConfig.manageRoot + 'Admin/Marketing/ExpertUser.aspx';
 
  /**
   * 爬虫管理
   */
  static webCrawler: string = RouteConfig.manageRoot + 'Admin/Marketing/Reptile.aspx';
  /**
   * 会议报名管理
   */
  static CSFMeeting: string = RouteConfig.manageRoot + 'CSFmeeting';

  /**
   * 行业会议管理
   */
  static industryConference: string = RouteConfig.manageRoot + 'Admin/ConferenceList';

  /**
   * 积分管理
   */
  static pointsCenter: string = RouteConfig.manageRoot + 'Admin/PointsCenter.aspx';

  /**
   * 积分中心
   */
  static pointCenter: string = RouteConfig.root + 'account.html#/user/point-center';

  /**
   * 市场热点 -- 心心数排行
   */
  static hotSpot: string = RouteConfig.root + 'market.html#/hotspot/';

  /**
   * 我的报价
   */
  static myQuote: string = RouteConfig.root + 'investment.html#/trade/my-quote';

  /**
   * 二级报价
   */
  static secondaryQuote: string = RouteConfig.root + 'investment.html#/trade/secondary-market';

  /**
   * 路演详情
   */
  static roadshowDetail: string = RouteConfig.root + 'market.html#/roadshow/detail?id=';
  /** 
   * API列表
   */
  static apiList: string = RouteConfig.root + 'openapi.html#/list';

  /** 
   * API详情页面
   */
  static apiDocuments: string = RouteConfig.root + 'openapi.html#/detail/documents';

  /**
   * 我的数据
   */
  static apiMyData: string = RouteConfig.root + 'openapi.html#/my-data';
  
  /** 
   * reits-产品要素
   */
  static reitsDealInfo: string = RouteConfig.root + 'product.html#/reits/basic-info';

  /** 
   * 债券计算器
   */
  static calculator: string = RouteConfig.root + 'investment.html#/analysis/calculator';

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/config/routeConfig.ts